
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import SelectItem2 from "components/Varios/SelectNew";
import { Table, Button, Input, PaginationItem, PaginationLink, Pagination, Row, Col, Label, FormGroup } from "reactstrap"
import { ObtenerAniosPlanificacionHE, ObtenerInformacionPlanificacionUnidadesHE, ObtenerMesesPlanificacionHE } from "./FunctionsPlanificacionUnidades";
import { alertService } from "components/Varios/alert_service";
import { DetallePlanificacionUnidadesHE, MesesPlanificacionHEDTO } from "./TypesPlanificacionUnidades";
import Cargando from "components/Varios/Cargando";
import CardRegimenHE from "components/DirectivoUnidad/Horas Extras/PlanificacionHE/CardRegimenHE";
import TablaPlanificacionUnidadesHE from "./TablaPlanificacionUnidadesHE";
import { showAlert } from '../Parametros Horas Extras/Actividades/ActividadesHorasExtras';

export default function PlanificacionUnidades() {
    var defaultPlanificacionUnidades: DetallePlanificacionUnidadesHE = { 
        listadoRegimenLaboralesPlan:[],
        unidadesPlanificacion: [],
        listadoRegimenLaborales: [],
        planificacionTotal:{
            valorTotalizadoRegimen: [],
            valorTotalPlanificacion: 0
        }
    }

    const TITULO_PANTALLA = `RESUMEN DE LAS PLANIFICACIONES MENSUALES DE HORAS EXTRAS`;

    const [loading, setloading] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const [aniosPlanificacion, setAniosPlanificacion] = useState<number[]>([]);
    const [mesesPlanificacion, setMesesPlanificacion] = useState<MesesPlanificacionHEDTO[]>([]);

    const [anioSeleccionado, setAnioSeleccionado] = useState<number>(0);
    const [mesSeleccionado, setMesSeleccionado] = useState<number>(0);

    const [infGeneralPlanificacionUnidades, setinfGeneralPlanificacionUnidades] = useState<DetallePlanificacionUnidadesHE>(defaultPlanificacionUnidades);

    async function ObtenerAniosPlanificacion() {
        setloading(true)
        const informacionGeneral = await ObtenerAniosPlanificacionHE();
        if (informacionGeneral.status === 200 && typeof informacionGeneral.dataResponse !== 'string') {
            setAniosPlanificacion(informacionGeneral.dataResponse)
            setErrorMessage(null);
        } else {
            setAniosPlanificacion([]); // Set an empty state
            setErrorMessage(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); // Set the error message
            alertService.error(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); // Show the error alert
        }
        setloading(false)
    }

    async function ObtenerMesesPlanificacionbyAnio() {
        const informacionGeneral = await ObtenerMesesPlanificacionHE(anioSeleccionado);
        if (informacionGeneral.status === 200 && typeof informacionGeneral.dataResponse !== 'string') {
            setMesesPlanificacion(informacionGeneral.dataResponse)
            setErrorMessage(null);
        } else {
            setMesesPlanificacion([]); // Set an empty state
            setErrorMessage(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); // Set the error message
            alertService.error(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); // Show the error alert
        }
    }

    async function ObtenerInfPlanificacionUnidades() {
        const informacionGeneral = await ObtenerInformacionPlanificacionUnidadesHE(anioSeleccionado, mesSeleccionado);
        
        if (informacionGeneral.status === 200 && typeof informacionGeneral.dataResponse !== 'string') {
            setinfGeneralPlanificacionUnidades(informacionGeneral.dataResponse)
            setErrorMessage(null);
        } else {
            setinfGeneralPlanificacionUnidades(defaultPlanificacionUnidades); // Set an empty state
            setErrorMessage(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); // Set the error message
            alertService.error(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); // Show the error alert
        }
    }


    useEffect(() => {
        ObtenerAniosPlanificacion()
    }, [])

    useEffect(() => {
        ObtenerMesesPlanificacionbyAnio()
    }, [anioSeleccionado])

    useEffect(() => {
        if(anioSeleccionado !== 0 && mesSeleccionado !== 0){
            ObtenerInfPlanificacionUnidades()
        }
        
    }, [anioSeleccionado, mesSeleccionado])

    const handleChangeSelect = (setter: Dispatch<SetStateAction<number>>) => (value: string | number) => {
        setter(Number(value)); 
    };

    const RefrescarTabla = async (anioSeleccionado: number, mesSeleccionado: number) => {
        setloading(true);
        const respuestaTabla = await ObtenerInformacionPlanificacionUnidadesHE(anioSeleccionado, mesSeleccionado);
    
        if (respuestaTabla.status === 200 && typeof respuestaTabla.dataResponse !== 'string') {
            setinfGeneralPlanificacionUnidades(respuestaTabla.dataResponse);
        } else {
            setinfGeneralPlanificacionUnidades(defaultPlanificacionUnidades); 
            setErrorMessage(typeof respuestaTabla.errorMessage === 'string' ? respuestaTabla.errorMessage : 'Error desconocido'); // Set the error message
            alertService.error(typeof respuestaTabla.errorMessage === 'string' ? respuestaTabla.errorMessage : 'Error desconocido');
        }
    
        setloading(false);
    };



    const contenidoCardRegimen = (
        <Row>
            <Col xl={12}>
                <Row>
                    {infGeneralPlanificacionUnidades.listadoRegimenLaboralesPlan.map((regimen, index) => (
                        <Col xl={4} key={index} className="mb-3 same-height-container">
                            <CardRegimenHE
                                regimenLaboralPlan={regimen}
                                index={index}
                                tipo="PLANIFICACION"
                                
                            />
                        </Col>
                    ))}
                </Row>
            </Col>
        </Row>
    );

    return (
        <div className='content'>
            <div className="titulo_seccion mb-3"> 
                {TITULO_PANTALLA}                
            </div>

            <Row>
                <Col xl={2}>
                    <FormGroup>
                        <Label for="anio">Año*</Label>
                        <SelectItem2
                            options={aniosPlanificacion.map(anio => ({ value: anio, label: anio }))}
                            placeholder=""
                            name="anio"
                            id="anio"
                            icon="fa-caret-down"
                            value={anioSeleccionado}
                            onChange={handleChangeSelect(setAnioSeleccionado)}
                        />
                    </FormGroup>
                </Col>
                <Col xl={2}>
                    <FormGroup>
                        <Label for="mes">Mes*</Label>
                        <SelectItem2
                            options={mesesPlanificacion.map(mes => ({ value: mes.numeroMes, label: mes.nombreMes }))}
                            placeholder=""
                            name="mes"
                            id="mes"
                            icon="fa-caret-down"
                            value={mesSeleccionado}
                            onChange={handleChangeSelect(setMesSeleccionado)}
                        />
                    </FormGroup>
                </Col>
            </Row>

            <>
            {loading && <Cargando />}
            {!loading && anioSeleccionado !== 0 && mesSeleccionado !== 0 && (
                <>
                {contenidoCardRegimen}
                <TablaPlanificacionUnidadesHE
                    unidadesPlanificacion={infGeneralPlanificacionUnidades.unidadesPlanificacion}
                    regimendisponible={infGeneralPlanificacionUnidades.listadoRegimenLaborales}
                    defaultRowNumber={50}
                    planificacionTotal={infGeneralPlanificacionUnidades.planificacionTotal}
                    onActualizarTabla={() => RefrescarTabla(anioSeleccionado, mesSeleccionado)}
                    anio={anioSeleccionado}
                    mes={mesSeleccionado}
                />
                </>
            )}

            </>
        </div>
    )
}
